export default __webpack_public_path__ + "static/media/masonYuyi.d81a21d1.png";